import { IconButton } from '@components/iconButton';
import { Share as ShareIcon } from '@assets/svgs';
import { Tooltip } from '@components/tooltip';
import { ToastType } from '@components/toast';
import { useSnackbar } from 'notistack';
import { useStore } from '@store/GlobalStore';
import { shallow } from 'zustand/shallow';
import { Theme } from '@mui/material/styles';

const copyUrl = (url: string) => navigator.clipboard.writeText(url);

export const ShareButton = () => {
  const [currentUser, userAuth] = useStore((state) => [state.currentUser, state.userAuth], shallow);
  const { isInternalUser } = userAuth;
  const { enqueueSnackbar } = useSnackbar();

  const getURL = () => {
    const url = new URL(window.location.href);
    if (!isInternalUser) {
      const brokerageId = currentUser?.brokerageUsers?.[0]?.brokerageId ?? '';
      url.searchParams.append('brokerageId', brokerageId);
    }
    return url.toString();
  };

  const handleCopyURL = async () => {
    const url = getURL();
    copyUrl(url);
    enqueueSnackbar('Copied to clipboard', {
      variant: ToastType.Success,
      preventDuplicate: true,
    });
  };

  return (
    <Tooltip title='Share this URL' arrow={false}>
      <IconButton
        id='search-button'
        variant='circular'
        onClick={handleCopyURL}
        aria-label='search-button'
        aria-valuetext='search-button'
        sx={{
          path: {
            color: 'text.main',
            stroke: (theme: Theme) => `${theme.palette.text.main} !important`,
          },
        }}
      >
        <ShareIcon width='16px' height='15px' />
      </IconButton>
    </Tooltip>
  );
};
